/* Agente Site 2026-09-17 — melhorias progressivas da página da obra. */
(function () {
  function limpa(t) { return (t || '').replace(/\s*[-–]?\s*AAS\s*#?\s*\d{3,6}\s*/i, ' ').replace(/\s{2,}/g, ' ').trim(); }

  function init() {
    var form = document.querySelector('form.contact-form__form');
    if (!form) return;
    var caixa = form.closest('.contact-form') || form;

    // obra vendida: nenhum canal de contato fica de pé
    if (document.querySelector('.aecio-vendida')) { caixa.remove(); return; }

    // mensagem sem o código interno
    var msg = caixa.querySelector('textarea');
    if (msg && /AAS/i.test(msg.value)) { msg.value = limpa(msg.value); }

    if (caixa.closest('details.aecio-email')) return;
    var rot = document.getElementById('aecio-email-label');
    var det = document.createElement('details');
    det.className = 'aecio-email';
    var sum = document.createElement('summary');
    sum.textContent = (rot && rot.textContent.trim()) || 'E-mail';
    det.appendChild(sum);
    caixa.parentNode.insertBefore(det, caixa);
    det.appendChild(caixa);
  }

  function agenda() { init(); setTimeout(init, 600); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', agenda, { once: true });
  else agenda();
  document.addEventListener('shopify:section:load', init);
})();


/* Agente Site 2026-09-18 — vídeos ambiente da home: só baixam quando entram na tela (480p no celular),
   pausam fora dela; com "reduzir movimento" ou economia de dados fica só o pôster. */
(function () {
  var vids = [].slice.call(document.querySelectorAll('video.aecio-video'));
  if (!vids.length) return;
  var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var economia = navigator.connection && navigator.connection.saveData;
  if (reduz || economia || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.getAttribute('src')) v.src = (window.innerWidth < 750 ? v.dataset.sd : v.dataset.hd) || v.dataset.hd;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else { v.pause(); }
    });
  }, { rootMargin: '200px 0px', threshold: 0.1 });
  vids.forEach(function (v) { io.observe(v); });
})();
